import { render, staticRenderFns } from "./CrosswordPublisherCopy.vue?vue&type=template&id=6b02756e&"
import script from "./CrosswordPublisherCopy.vue?vue&type=script&lang=js&"
export * from "./CrosswordPublisherCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports